import { Button, Group, Modal, Stack } from "@mantine/core";

interface WhichUserModalProps {
  isOpen: boolean;
  questionText: string;
  toggle: () => void;
  onClickSystemUser: () => void;
  onClickSelf: () => void;
}

function WhichUserModal({
  isOpen,
  questionText,
  toggle,
  onClickSystemUser,
  onClickSelf
}: WhichUserModalProps) {
  return (
    <Modal
      className="WhichUserModal"
      opened={isOpen}
      withCloseButton={false}
      onClose={toggle}
    >
      <Stack align="center" gap="lg" my="lg">
        {questionText}
        <Group gap="lg">
          <Button onClick={onClickSystemUser}>Als Systemnutzer</Button>
          <Button onClick={onClickSelf}>Unter meinem Namen</Button>
        </Group>
      </Stack>
    </Modal>
  );
}

export { WhichUserModal, WhichUserModalProps };
